<template>
  <div class="to_app_container" :style="wxEnvPaddingTop">
    <w-nav-bar
      :icon="'iconchevron-left'"
      :nav_title="type === 'invite' ? '领取成功' : ''"
      @mobileLeftBtn="leftBtnClick"
      v-show="iosOrAndroidShow && !isWxMini"
    />
    <div class="mobile-page-container" v-if="type === 'person'">
      <div class="container">
        <img src="https://files.wondercv.com/m/toApp/person_hr1.png" alt="" @click="goToApp">
      </div>
      <div class="submit-btn" @click="goToApp">去APP沟通</div>
    </div>
    <div class="wxmini-container" v-else-if="type === 'other'">
      <div class="back_img" @click="goToApp">
        <div class="logo"></div>
        <div class="download_btn">打开APP</div>
      </div>
      <div>
        <img class="bottom_icon" src="https://files.wondercv.com/mobile/wondercv_logo.png" alt="">
      </div>
      <!-- <div class="desc">2021年度必备求职神器</div> -->
    </div>
    <div class="invite-container" v-else-if="type === 'invite'">
      <div class="popup" @click="goToApp">
        <span>已发放至账户  {{ phoneNumber }}</span>
      </div>
      <div class="footer-text">2021年度必备求职神器</div>
    </div>
    <div class="campus-offers-container" :style="isWxMini ? {'padding-top': 0} : {}" v-else-if="type === 'campusOffer'">
      <div class="img-content" @click="goToApp">
        <img src="https://files.wondercv.com/m/toApp/campus-offer-app.png" alt="">
      </div>
    </div>
    <div class="mobile-page-container" v-else-if="type === 'group'">
      <div class="container">
        <img src="https://files.wondercv.com/m/toApp/hr1.png" alt="" @click="goToApp">
      </div>
      <div class="submit-btn" @click="goToApp">打开超级简历</div>
    </div>
    <div class="team-chat-container" v-else-if="type === 'teamChat'">
      <div class="container">
        <img src="https://files.wondercv.com/m/toApp/person_hr1.png" alt="" @click="goToApp">
      </div>
      <div class="submit-btn" @click="teamChatOpenApp">去APP加入群聊</div>
    </div>
    <w-share-wx :state="wxState" desc="在默认浏览器中打开" @handleClose="changeWxState"/>
  </div>
</template>

<script>
import {envMixin, downloadAPPMixin} from '@/assets/js/mixin/global'
import WNavBar from "@/components/global/w-navbar";
import WShareWx from '@/components/global/w-share-wx'

export default {
  name: "welcome_to_app",
  mixins: [envMixin, downloadAPPMixin],
  components: {
    WNavBar,
    WShareWx
  },
  data() {
    return {
      mobile: '',
      origin: window.location.origin,
      type: '',
      phoneNumber: '',
      wxState: false
    }
  },
  computed: {
    wxEnvPaddingTop() {
      return this.isWxMini ? 0 : '44px'
    }
  },
  mounted() {
    let md = new MobileDetect(navigator.userAgent);
    this.mobile = md.os();
    // 没有参数默认 group 从机构号邀请跳转过来的
    this.type = this.$route.query.type || 'group'
    let open = this.$route.query.open
    if (this.type === 'invite') {
      let number = this.$route.query.phone
      this.phoneNumber = `${number.slice(0,3)}****${number.slice(-4)}`
    }
    // this.teamChatOpenApp()
    /***
     * type类型：从什么地方跳转到引导页
     * 1.person：从职位详情继续沟通跳转
     * 2.other：从帖子详情等其他地方跳转
     * 3.invite：被邀请注册的新用户跳转
     * 4.参数为空(默认为 group )：被机构号邀请注册的新用户跳转
     * 5.campusOffer：校招跳转
     * ***/
    // 从 open 引导页跳转过来的就打开App Store
    if (open && this.mobile === 'iOS') {
      window.location.href = 'https://itunes.apple.com/cn/app/%E8%B6%85%E7%BA%A7%E7%AE%80%E5%8E%86-%E5%AE%9E%E4%B9%A0%E6%89%BE%E5%B7%A5%E4%BD%9C%E5%BF%85%E5%A4%87/id1327732591?mt=8'
    }else if (open && this.mobile !== 'iOS') {
      window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.wondercv';
    }
  },
  // 路由守卫拦截
  beforeRouteEnter (to, from, next) {
    // 路由拦截，根据手机系统不同跳转App Store或者应用宝
    let osType = new MobileDetect(navigator.userAgent).os()
    if (from.path === '/wondercv_app/open_app' && osType === 'iOS') {
      window.location.href = 'https://itunes.apple.com/cn/app/%E8%B6%85%E7%BA%A7%E7%AE%80%E5%8E%86-%E5%AE%9E%E4%B9%A0%E6%89%BE%E5%B7%A5%E4%BD%9C%E5%BF%85%E5%A4%87/id1327732591?mt=8'
    }else if (from.path === '/wondercv_app/open_app' && osType !== 'iOS'){
      window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.wondercv';
    }
    next()
  },
  methods: {
    // 群聊二维码打开APP
    teamChatOpenApp() {
      // 群二维码打开的直接启动APP
      if (this.type === 'teamChat') {
        let link = {
          ios: `https://www.wondercv.${process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com'}/wondercv_app/open_app?type=teamChat&tid=${this.$route.query.tid}&open_type=teamChat`,
          // ios: `https://www.wondercv.cn/wondercv_app/open_app?type=teamChat&tid=${this.$route.params.tid}&open_type=teamChat`,
          android: `android://h5/open?tid=${this.$route.params.tid}&type=teamChat`,
        }
        // 安卓手机在微信环境无法启动APP 打开引导
        if (this.mobile !== 'iOS' && (this.isWechatBrowser || this.isWxMini)) {
          this.wxState = true
        } else {
          this.openApp(link, false)
        }
      }
    },
    // 关闭引导弹层
    changeWxState() {
      this.wxState = false
    },
    // 返回上层
    leftBtnClick() {
      this.$router.back()
    },
    // 判断安卓手机型号
    checkAgent(type) {
      let userAgent = type.toLowerCase()
      let isHuawei = userAgent.match(/huawei/i) == "huawei";
      let isHonor = userAgent.match(/honor/i) == "honor";
      let isOppo = userAgent.match(/oppo/i) == "oppo";
      let isOppoR15 = userAgent.match(/pacm00/i) == "pacm00";
      let isVivo = userAgent.match(/vivo/i) == "vivo";
      let isXiaomi = userAgent.match(/mi\s/i) == "mi ";
      let isXiaomi2s = userAgent.match(/mix\s/i) == "mix ";
      let isRedmi = userAgent.match(/redmi/i) == "redmi";
      let isSamsung = userAgent.match(/sm-/i) == "sm-";
      if (isHonor || isHuawei) {
        window.location.href = "appmarket://details?id=com.wondercv"  //华为
      }else if (isOppo || isOppoR15) {
        window.location.href = "oppomarket://details?packagename=com.wondercv"  //oppo;
      }else if (isVivo) {
        window.location.href = "vivoMarket://details?id=com.wondercv";  // vivo
      }else if (isXiaomi || isRedmi || isXiaomi2s) {
        window.location.href = "mimarket://details?id=com.wondercv";  //小米
      }else if (isSamsung) {
        window.location.href = "samsungapps://ProductDetail/com.wondercv";    // 三星
      }else {
        window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.wondercv';
      }
    },
    // 打开APP或者应用商店
    goToApp() {
      // iOS
      if (this.mobile === 'iOS') {
        // window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.wondercv';
        if (this.type) {
          window.location.href = `https://www.wondercv.${ process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com' }/wondercv_app/open_app?type=${ this.type }&phone=${ this.phoneNumber }&tid=${this.$route.query.tid}`;
        }else {
          window.location.href = `https://www.wondercv.${ process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com' }/wondercv_app/open_app`;
        }
        // AndroidOS
      }else {
        // 调用安卓协议打开APP  没有安装APP则跳转应用宝
        window.location.href = 'android://h5/open'
        let t = Date.now();
        setTimeout(()=> {
          if (Date.now() - t < 1200) {
            if (this.isWxMini) {
              switch(this.type) {
                case 'person': this.$router.push({ path: '/wondercv_app/open_app', query: { type: 'person' } }); break;
                case 'invite': this.$router.push({ path: '/wondercv_app/open_app', query: { type: 'invite' } }); break;
                case 'campusOffer': this.$router.push({ path: '/wondercv_app/open_app', query: { type: 'campusOffer' } }); break;
                case 'other': this.$router.push({ path: '/wondercv_app/open_app', query: { type: 'other' } }); break;
                case 'group': this.$router.push({ path: '/wondercv_app/open_app', query: { type: 'group' } }); break;
                case 'teamChat': this.$router.push({ path: '/wondercv_app/open_app', query: { type: 'teamChat', tid: this.$route.query.tid } }); break;
              }
              // if (this.type === 'person') {
              //   this.$router.push({ path: '/wondercv_app/open_app', query: { type: 'person' } })
              // } else if (this.type === 'invite') {
              //   this.$router.push({ path: '/wondercv_app/open_app', query: { type: 'invite' } })
              // } else if (this.type === 'campusOffer') {
              //   this.$router.push({ path: '/wondercv_app/open_app', query: { type: 'campusOffer' } })
              // } else {
              //   this.$router.push({ path: '/wondercv_app/open_app' })
              // }
            } else {
              window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.wondercv';
            }
            // this.checkAgent(navigator.userAgent)
          }
        }, 1000);
      }
    }
  }
}
</script>

<style lang="scss">
@media only screen and (min-width: 1024px) {
  body{
    width: 375px;
    margin: 0 auto!important;
  }
  html{
    font-size: 110px!important;
  }
}
</style>

<style lang="scss" scoped>
@import "../../assets/scss/global/variable";

.to_app_container {
  width: 375px;
  height: auto;

  .invite-container {
    width: 100%;
    height: calc(100vh - 44px);
    margin-top: 44px;
    background: url('https://files.wondercv.com/new_invite/download_back.png') no-repeat;
    background-size: 100% 100%;
    position: relative;
    .popup {
      width: 314px;
      height: 346px;
      border-radius: 20px 20px 0px 0px;
      background: url('https://files.wondercv.com/new_invite/new_popup.png') no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      span {
        font-size: 12px;
        font-weight: 300;
        color: #FFFEEC;
        line-height: 17px;
        position: absolute;
        left: 50%;
        bottom: 101px;
        transform: translateX(-50%)
      }
    }
    .footer-text {
      width: 100%;
      font-size: 12px;
      color: #F7F7F7;
      letter-spacing: 6px;
      position: absolute;
      bottom: 33px;
      text-align: center;
    }
  }
  .campus-offers-container {
    padding-top: 44px;
    .img-content {
      border-top: 8px solid #f9f9f9;
      padding-top: 70px;
      img {
        width: 100vw;
      }
    }
  }
  .wxmini-container{
    width: 375px;
    height: auto;
    background-color: #fff;
    color: #404040;
    overflow: hidden;
    text-align: center;
    font-size: $font-size-medium-x;
    .bottom_icon{
      width: 102px;
      height: 24px;
      display: block;
      margin: auto;
      margin-top: 33px;
    }
    .back_img {
      width: 100%;
      height: 555px;
      background: url("https://files.wondercv.com/download/download_back_img.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      .logo {
        width: 260px;
        height: 75px;
        background: url("https://files.wondercv.com/mobile/advert.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 132px;
        left: 52%;
        transform: translate(-50%);
      }
      .download_btn {
        width: 253px;
        height: 50px;
        background: #FFFFFF;
        box-shadow: 0px 3px 6px 0px rgba(235, 85, 52, 0.6);
        border-radius: 25px;
        position: absolute;
        left: 50%;
        bottom: 72px;
        transform: translate(-50%);
        font-size: 16px;
        font-weight: 500;
        color: #FF6644;
        line-height: 50px;
        letter-spacing: 1px;
      }
    }
    .desc {
      width: 100%;
      height: 110px;
      font-size: 12px;
      font-weight: 400;
      color: #606060;
      line-height: 110px;
      letter-spacing: 6px;
    }
  }
  .mobile-page-container {
    margin-top: 0px;
    padding-top: 50px;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-content: flex-start;
    //align-items: flex-start;
    flex-wrap: wrap;

    .container{
      width: 272px;
      height: 373px;
      img{
        width: 100%;
        height: 100%;
      }
    }

    .logo {
      width: 58px;
      height: 58px;
      margin-top: 28px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .desc {
      width: 100%;
      color: #404040;
      font-size: $font-size-small;
      text-align: center;
      margin-top: 12px;
    }

    .content {
      font-size: $font-size-large;
      margin-top: 8px;
    }

    .example {
      width: 272px;
      height: 244px;
      margin-top: 16px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .submit-btn {
      width: 303px;
      height: 46px;
      margin-top: 36px;
      line-height: 46px;
      text-align: center;
      border-radius: 23px;
      background-color: #ff6644;
      font-size: $font-size-medium-x;
      color: #fff;
    }
  }
  .team-chat-container {
    margin-top: 0px;
    padding-top: 50px;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-content: flex-start;
    //align-items: flex-start;
    flex-wrap: wrap;

    .container{
      width: 272px;
      height: 373px;
      img{
        width: 100%;
        height: 100%;
      }
    }

    .logo {
      width: 58px;
      height: 58px;
      margin-top: 28px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .desc {
      width: 100%;
      color: #404040;
      font-size: $font-size-small;
      text-align: center;
      margin-top: 12px;
    }

    .content {
      font-size: $font-size-large;
      margin-top: 8px;
    }

    .example {
      width: 272px;
      height: 244px;
      margin-top: 16px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .submit-btn {
      width: 303px;
      height: 46px;
      margin-top: 36px;
      line-height: 46px;
      text-align: center;
      border-radius: 23px;
      background-color: #ff6644;
      font-size: $font-size-medium-x;
      color: #fff;
    }
  }
}
</style>
